import script from "./ShippingMethodPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingMethodPage.vue?vue&type=script&setup=true&lang=js"

import "./ShippingMethodPage.vue?vue&type=style&index=0&id=e312b2c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e312b2c6"]])

export default __exports__